import { LocalizedTextDTO } from '../DTOs/LocalizedTextDTO';

export class LocalizedText {
  public static getEmptyLocalizedText() {
    return new LocalizedText('', '');
  }

  public static fromDTO(localizedTextDTO: LocalizedTextDTO) {
    return new LocalizedText(localizedTextDTO.language, localizedTextDTO.text, localizedTextDTO.id?.toString());
  }

  public toDTO() {
    return new LocalizedTextDTO(this.language, this.text, Number(this.id) || undefined);
  }

  constructor(
    public language: string,
    public text: string,
    public id?: string,
  ) {}
}
